<ng-container *ngIf="currentConfig$ | async as config">
  <ng-container *ngIf="currentMerchant$ | async as merchant">
    <div class="content-wrap">
      <section class="card">
        <app-card-info
          [merchant]="merchant"
          [total]="transactions ? transactions.totalAmount : 0"
          [currency]="transactions ? transactions.currency : 'EUR'"
          [totalPayment]="transactions ? transactions.totalAmountPayment : 0"
          [currencyPayment]="
            transactions ? transactions.currencyPayment : 'EUR'
          "
        ></app-card-info>
        <app-card-controls></app-card-controls>
      </section>

      <hr class="no-print" *ngIf="config.showPartners" />

      <section class="partners" *ngIf="config.showPartners">
        <app-partners></app-partners>
      </section>

      <hr class="no-print" />

      <ng-container *ngIf="overviewMode$ | async as overviewMode">
        <section class="tabs no-print">
          <button
            class="btn tab"
            [class.active]="overviewMode === overviewModes.TRANSACTIONS"
            (click)="onChangeOverviewMode(overviewModes.TRANSACTIONS)"
          >
            {{ "home.tabs.transactions" | translate }}
          </button>
          <button
            class="btn tab"
            [class.active]="overviewMode === overviewModes.CASHCUTS"
            (click)="onChangeOverviewMode(overviewModes.CASHCUTS)"
          >
            {{ "home.tabs.cashcuts" | translate }}
          </button>
        </section>

        <hr class="no-print" />

        <section>
          <app-request-filter
            class="no-print"
            [availablePos]="merchant.pointOfSales"
          ></app-request-filter>
        </section>

        <section [ngSwitch]="overviewMode">
          <app-cashcut-list
            *ngSwitchCase="overviewModes.CASHCUTS"
          ></app-cashcut-list>
          <app-transaction-list
            *ngSwitchCase="overviewModes.TRANSACTIONS"
          ></app-transaction-list>
        </section>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
